<template lang="pug">
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    title='editar banco'
    v-bind='formProps'
    v-model='gBank'
    @reset='submitReset'
    @submit='submitCreate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import TranslatorService from '@/services/translator'
  //
  import GBankFields from '@/views/General/GBank/GBankFields'
  import GBankModel from '@/models/General/GBank'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: GBankFields,
        }
      }
    },
    data() {
      return {
        gBank: new GBankModel({
          bank: '',
          code: '',
        }),
      }
    },
    methods: {
      getGBank() {
        return GBankModel.find(this.$route.params.id)
      },
      setGBank(gBank) {
        this.gBank = gBank.reset()
      },
      showCreateError(event) {
        this.$toast.error(TranslatorService(GBankModel, event.response.data))
      },
      showCreateSuccess() {
        this.$toast.success('Banco actualizado exitosamente')
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toUpdate)
          .then(this.toWait)
      },
      submitReset() {
        this
          .toWait(true)
          .then(this.getGBank)
          .then(this.setGBank)
          .then(this.toWait)
      },
      toUpdate() {
        return this
          .gBank
          .toUpdate()
          .save()
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
      },
      toRedirect() {
        this.$router.push({ name: 'g-bank-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle('Editar banco')
    },
    mounted() {
      this.submitReset()
    }
  }
</script>